var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getErrorMessage)?_c('div',{staticClass:"bg-red-100 border-l-4 border-red-500 text-red-500 p-4 text-xs",attrs:{"role":"alert"}},[_c('p',{staticClass:"font-bold"},[_vm._v("Error")]),_c('p',[_vm._v(_vm._s(_vm.getErrorMessage))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }